<template>
  <div class="card-container login-container">
    <login-form />
    <span class="divider" />
    <!-- <vendor-sign-buttons /> -->
    <span class="divider" />
    <div class="bottom-buttons-wrapper">
      <standard-button
        class="new-account-button fluid"
        class-type="secondary"
        @buttonClick="newAccountModal()"
        text="Zarejestruj nowe konto"
      />
      <p>lub</p>
      <standard-button
        class="new-visit-button fluid"
        @buttonClick="newVisitModal()"
        text="Umów wizytę bez rejestracji"
      />
    </div>
  </div>
</template>

<script>
import LoginForm from '~/LoginForm.vue';
// import VendorSignButtons from '~/VendorSignButtons';
import StandardButton from '~/StandardButton';
import { mapActions } from 'vuex';

export default {
  components: {
    LoginForm,
    // froze login via FB and Google
    // VendorSignButtons,
    StandardButton,
  },
  methods: {
    ...mapActions({
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setCallback: 'modal/setCallback',
      setModalStep: 'modal/setModalStep',
      setModalMode: 'modal/setModalMode',
      setModalContent: 'modal/setContent',
    }),
    newAccountModal() {
      this.setModalMode('logged-out');
      this.setModalStep('new_account');
      this.setModalContent({
        title: 'Rejestracja nowego konta',
        subtitle: 'Prosimy o podanie danych niezbędnych do założenia konta',
      });
      this.toggleModal();
    },
    newVisitModal() {
      this.setModalMode('logged-out');
      this.setModalStep('first_step');
      this.setModalContent({
        title: 'Umów się na wizytę',
        subtitle: 'Podaj parametry Twojego samochodu',
      });
      this.toggleModal();
    },
  },
  mounted() {
    if (this.$route.query.visit) {
      this.newAccountModal();
    }
  },
};
</script>
